<template>
    <div>
        <h4 class="title1">
            <el-button icon="el-icon-back" @click="goback" circle></el-button><span>&nbsp;&nbsp;试卷
                （姓名：{{result.name}}&nbsp;&nbsp;&nbsp;身份证：{{result.agentCode}}&nbsp;&nbsp;&nbsp;险种编码：{{result.riskCode}}）
            </span>
        </h4>
        <div class="main">
            <el-row class="row">
              
                <el-col :span="3">
                    考试规定时长：60分
                </el-col>
               
                <el-col :span="2">
                    考题：{{result.questionCount}}题
                </el-col>
               
                <el-col :span="2">
                   满分：100分
                </el-col>
                
                <el-col :span="3">
                    考试分数： {{result.score}}分
                </el-col><el-col :span="2">
                    对： {{result.countOfCorrect}}题
                </el-col><el-col :span="2">
                    错： {{result.countOfWrong}}题
                </el-col>
                  <el-col :span="5">
                    开考时间：{{result.examStartDate}}
                </el-col>
                <el-col :span="5">
                    结束时间：{{result.examEndDate}}
                </el-col>
            </el-row>
            <div class="showSort"><el-checkbox v-model="checked">按照错题在前的顺序排序</el-checkbox></div>
            <div class="questions">
                <template v-if="checked">
                    <div v-for="(item,idx) in errorInfrontList" :key="idx">
                        <el-row class="title">
                            <el-col :span="20">
                                <el-row>
                                    <el-col :span="1">{{(item.index+1)+'.'}}</el-col>
                                    <el-col :span="23" :class="answerNewList[idx]?'':'bkg'">{{item.subject}}</el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="4"><span class="correct">正确答案&nbsp;{{item.answer}}</span></el-col>
                        </el-row>
                        <el-row :class="[answerNewList[idx].indexOf(option.optionName)!=-1 ?(item.answer.indexOf(option.optionName)!=-1 ? 'green' : 'red'):'' ]" v-for="(option,index) in item.questionOptions" :key="index">
                            <el-col :span="1" style="text-align:right;">
                                <span :class="[answerNewList[idx].indexOf(option.optionName)!=-1 ?(item.answer.indexOf(option.optionName)!=-1 ? 'el-icon-circle-check' : 'el-icon-circle-close'):'' ]">{{option.optionName}}&emsp;</span>
                            </el-col>
                            <el-col :span="19" class="optionDetail">
                                <span>{{option.optionDetail}}</span>
                            </el-col>
                        </el-row>
                    </div>
                </template>
                <template v-else>
                    <div class="question" v-for="(item,idx) in result.examQuestions" :key="idx">
                        <el-row class="title">
                            <el-col :span="20">
                                <el-row>
                                    <el-col :span="1">{{(idx+1)+'.'}}</el-col>
                                    <el-col :span="23" :class="answers[idx]?'':'bkg'">{{item.subject}}</el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="4"><span class="correct">正确答案&nbsp;{{item.answer}}</span></el-col>
                        </el-row>
                        <el-row :class="[answers[idx].indexOf(option.optionName)!=-1 ?(item.answer.indexOf(option.optionName)!=-1 ? 'green' : 'red'):'' ]" v-for="(option,index) in item.questionOptions" :key="index">
                            <el-col :span="1" style="text-align:right;">
                                <span :class="[answers[idx].indexOf(option.optionName)!=-1 ?(item.answer.indexOf(option.optionName)!=-1 ? 'el-icon-circle-check' : 'el-icon-circle-close'):'' ]">{{option.optionName}}&emsp;</span>
                            </el-col>
                            <el-col :span="19" class="optionDetail">
                                <span>{{option.optionDetail}}</span>
                            </el-col>
                        </el-row>
                    </div>
                </template>
            </div>
            <div class="footer">
                <el-row>
                    <el-col :span="1">
                        得分
                    </el-col>
                    <el-col :span="1">
                        {{result.score}}分
                    </el-col>
                    <el-col :span="2">
                        对{{result.countOfCorrect}}题
                    </el-col>
                    <el-col :span="2">
                        错{{result.countOfWrong}}题
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/modules/api.js'
import url from '@/modules/url.js'
export default {
  data () {
    return {
      examEndDate:'',
      result: '',
      elIconCircleCheck: 'el-icon-circle-check',
      answers: [],
      checked:false,
    //   errorListLeader:[],//错题列表容器
      correctList:[], //正确的替列表容器
      errorInfrontList:[], //错题在前的列表
      answerNewList:[], //排序之后的答案列表
    //   notAnswerList:[], // 没有作答的题目
    first:'',
    second:'',
    third:'',
    fourth:'',
    isActive:false,
    nuList:[],
    goBackDetail:'',
    riskCode:''
    }
  },
  methods: {
    init () {
      let paperCode = this.$route.params.paperCode
      let that = this
      let req = {
        paperCode: paperCode
      }
      api.post(url.reviewExamPaper, req, function (res) {
        that.result = res.data
        that.answers = res.data.answers.split(',')
        // console.log(res,'data')
        // that.answers.forEach((item,index)=>{
        //     console.log(item,'index')
        // })
      })
    },
    goback(){

        let req=this.$route.params.req
        let manageCom = this.$route.params.manageCom
        this.$router.push({name: 'paperDetails', params: {req:req,manageCom:manageCom}})
    }
  },
  mounted () {
      this.riskCode=this.$route.params.riskCode
    this.init()
  },
  computed:{

  },
  watch:{
      checked(val){
        if(val){
            // console.log(this.answers,'answers') //作答的答案
            // item.answer 正确的答案
            this.result.examQuestions.forEach((item,index) =>{
                if(this.answers[index] !== '' ){
                // console.log(index,'index')
                // console.log(this.nuList)
                if(this.nuList !== []){
                    this.nuList.forEach(nuItem=>{
                        if(nuItem===index){
                            this.isActive =true
                        }else{
                            this.isActive = false
                        }
                    })
                }
                   item.answer = item.answer.replace(/,/g,'')
                    if(this.answers[index].length >1){
                        let arr = this.answers[index].split('')
                        let Arr= arr.sort((a,b)=>{return a.localeCompare(b)})
                        let newStr = Arr.join('')
                        if(this.answers[index].length ==item.answer.length){
                            if(item.answer.indexOf(newStr) ===-1){
                                item.index = index
                                this.errorInfrontList.push(item)
                                this.answerNewList.push(this.answers[index])
                            }else if(item.answer.indexOf(newStr) !==-1){
                                item.index = index
                                this.correctList.push(item)
                            }
                        }else{
                            item.index = index
                            this.errorInfrontList.push(item)
                            this.answerNewList.push(this.answers[index])
                        }
 
                   }else{
                        if(item.answer!==this.answers[index]){
                            item.index = index
                            this.errorInfrontList.push(item)
                            this.answerNewList.push(this.answers[index])
                        }else if(item.answer==this.answers[index]){
                            item.index = index
                            this.correctList.push(item)
                        }
                   }
                    // if(item.answer.indexOf(this.answers[index]) ===-1){
                    //     // console.log(this.answers[index],index,'enterin')
                    //     // this.errorListLeader.push(item)
                    //     item.index = index
                    //     this.errorInfrontList.push(item)
                    //     this.answerNewList.push(this.answers[index])
                    // }else if(item.answer.indexOf(this.answers[index]) !==-1){
                    //     // console.log(this.answers[index],index)
                    //     item.index = index
                    //     this.correctList.push(item)
                    // }
                }else{
                    // this.notAnswerList.push(item)
                    if(this.answers[index]==''){
                        this.nuList.push(index)
                        this.nuList.forEach(nuItem=>{
                            if(nuItem===index){
                                this.isActive =true
                            }else{
                                this.isActive = false
                            }
                        })
                    }
                    item.index = index
                    this.errorInfrontList.push(item)
                    this.answerNewList.push(this.answers[index])
                }
            })
            // this.notAnswerList.forEach(item =>{
            //     this.errorInfrontList.push(item)
            //     this.answerNewList.push('')
            // })
            // console.log(this.correctList,'111')
            console.log(this.errorInfrontList,'22')
            this.correctList.forEach((item,index)=>{
                this.errorInfrontList.push(item)
                this.answerNewList.push(item.answer)
            })
        }else{
            this.errorInfrontList = []
            this.correctList = []
            // this.errorListLeader =[]
            // this.notAnswerList = []
        }
      }
  }
}
</script>

<style scoped>
.title1{
    background: #e0e0e0;
    height:50px;
    line-height: 50px;
    margin: 0px 0px 0px 0px;
}
.main{
    height: auto;
    overflow: hidden;
}
.row{
    padding-left: 20px;
    font-size: 13px;
    height: 30px;
    line-height: 30px;
    border-bottom: 1px solid #f2f2f2;
}
.questions{
   width: 98%;
   margin: 0 auto;
   padding: 20px;
   line-height:27px;
}
.bkg{
    width:auto;
    /* background-color: #f33; */
    color:#f33;
}
.question label{
    border-bottom: 1px solid #f2f2f2;
    display: block;
    width: 100%;
    height: auto;
    line-height: 30px;
}
.green{
    color: #4DCD16;
}
.red{
    color: #FF6041;
}
.footer{
    color: #ff9900;
    padding-left: 20px;
    height: 30px;
    background: #f5f5f5;
    line-height: 30px;
}
.orange{
    color: #ff9900;
}
.correct{
    float: right;
    color: #4DCD16;
    position: relative;
    right: 50px;
}
.optionDetail{
    text-align: left;
}
.optionName{
    display: block;
    float: left;
    width: 5%;
    line-height: 30px;
}
.showSort{
    padding-left:20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examManage/paperReview.vue